import { DraggableBox } from '@app/engine/ui/draggable-box';
import { html } from '@app/engine/utils/development/formatter';
import { getEl, showEl } from '@app/engine/utils/get-el';
import { keepTrackApi } from '@app/keepTrackApi';
import { LayersManager } from './layers-manager';
export class LayersPopupBox extends DraggableBox {
    constructor() {
        super('layers-popup-box', { title: 'Layers', width: '325px' });
    }
    getBoxContentHtml() {
        return html `
      <div id="layers-hover-menu-popup">
      </div>
    `.trim();
    }
    onOpen() {
        super.onOpen();
        LayersManager.change(settingsManager.currentLayer);
        showEl(getEl('layers-hover-menu-popup'));
        getEl('layers-hover-menu-popup')?.addEventListener('click', (e) => {
            const hoverMenuItemClass = e.target?.classList[1];
            if (hoverMenuItemClass) {
                keepTrackApi.getUiManager().layersManager.layersHoverMenuClick(hoverMenuItemClass);
            }
        });
    }
    close(cb) {
        super.close(cb);
        const layersMenuIconContainer = getEl('layers-menu-icon').parentElement;
        layersMenuIconContainer.classList.remove('bmenu-item-selected');
        layersMenuIconContainer.classList.add('top-menu-icons__blue-img');
        keepTrackApi.getUiManager().layersManager.isLayersMenuOpen = false;
    }
}
